import React, { useRef } from 'react';
import { Waypoint } from 'react-waypoint';
import { CodetableTranslation } from 'app/area/indicator-factors/constants';
import { CodeListItem } from 'app/area/indicator-factors/list/types-store';
import { CodetableMetadata } from 'app/area/indicator-factors/types-store';
import { FilterSearchModel } from 'app/area/search-filters/types-store';
import { useWindowHeight } from 'app/area/indicator-factors/list/hooks';
import styles from './indicator-factors-table.scss';

interface IndicatorFactorsTableProps {
  data: CodeListItem[];
  requestedSearchModel: FilterSearchModel;
  fetchingData: boolean;
  numberOfResults: number;
  metadata: CodetableMetadata;
  translation: CodetableTranslation;
  children: React.ReactNode;
  loadMoreData: (searchModel: FilterSearchModel, startIndex: number) => void;
}

export const IndicatorFactorsTable: React.FC<IndicatorFactorsTableProps> = (props) => {
  const id = 'indicator-factors-list-table';
  const { metadata, translation, children,
    fetchingData,
    requestedSearchModel,
    data,
    numberOfResults,
    loadMoreData
  } = props;

  const { height } = useWindowHeight();

  const ref = useRef<HTMLDivElement>();

  const onLoadData = (searchModel: any, startIndex: number) => {
    if (startIndex !== undefined) {
      loadMoreData(searchModel, startIndex);
    }
  };

  const onFetchMore = () => {
    if (fetchingData || !data || data.length === 0 || data.length === numberOfResults) {
      return;
    }

    onLoadData(requestedSearchModel, data.length);
  };

  return <div id={id} className={styles.wrapper} style={{ maxHeight: height - 340 }} ref={ref}>
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.th5}>{translation.code_id}</th>
          <th className={styles.th2}>{translation.substance}</th>
          <th className={styles.th3}>{translation.indicatorSubstance}</th>
          {metadata.location && <th className={styles.th2}>{translation.location}</th>}
          {metadata.unit && <th className={styles.th2}>{translation.unit}</th>}
          {metadata.source && <th className={styles.th2}>{translation.source}</th>}
          {metadata.equipment && <th className={styles.th2}>{translation.equipment}</th>}
          <th className={styles.th3}>{translation.indicatorType}</th>
          <th className={styles.th1}>{translation.validFrom}</th>
          <th className={styles.th4}>{translation.factor}</th>
          <th className={styles.th5}>{translation.uoms}</th>
          <th className={styles.th6} />
        </tr>
      </thead>
      <tbody>
        {children}
        <tr>
          <td className={styles.waypoint}>
            <Waypoint key="wpIndicatorFactors" onEnter={onFetchMore} scrollableAncestor={ref.current} />
          </td>
        </tr>
      </tbody>
    </table>
  </div>;
};
